(function($) {
	'use strict';
	$.fn.Slide__ProductsTrigger = function() {
		this.each(function() { 

			/*
			 * Action: Add slide to collection
			 */
			var $self = $(this);
				
			
			// Listen for click
			$self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
				e.preventDefault();
				
				// Disable others
				$.HTML.removeClass('slide-insights-on');
				
				// Set user preference
				var pref = $.HTML.hasClass('slide-products-on') ? false : 'slide_products';
				$.Globals.ajax( 'scspaces_set_user_preference', { 'which' : 'show_on_slide', 'pref' : pref } );
				
				// Set the class
				$.HTML.toggleClass( 'slide-products-on' );
				
			});
			
		
		});
		return this;
	};
}(jQuery));